/* Indulge IPL hero — behaviour for sections/indulge-ipl-hero.liquid */
(function () {
  function init(root) {
    if (!root || root.dataset.iheroReady) return;
    root.dataset.iheroReady = '1';

    /* Gallery */
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var dots = [].slice.call(root.querySelectorAll('[data-dot]'));
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var index = 0;

    function show(i) {
      if (!slides.length) return;
      index = Math.max(0, Math.min(slides.length - 1, i));
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      var ti = Math.min(index, thumbs.length - 1);
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === ti); });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    var stage = root.querySelector('.ihero__stage'), startX = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { show(index + (dx < 0 ? 1 : -1)); swiped = Date.now(); }
        startX = null;
      }, { passive: true });
    }
    show(0);

    /* Large view (lightbox): tap a photo or the magnifier. Arrows, swipe and the keyboard move through the photos;
       pinch-zoom is left to the browser. Closing returns the gallery to the photo that was open. */
    var swiped = 0;
    var lb = root.querySelector('[data-lb]');
    if (lb && typeof lb.showModal === 'function' && slides.length) {
      var lbImg = lb.querySelector('[data-lb-img]');
      var lbCount = lb.querySelector('[data-lb-count]');
      var lbPrev = lb.querySelector('[data-lb-prev]'), lbNext = lb.querySelector('[data-lb-next]');
      var lbIndex = 0, lbStartX = null, lbTouches = 0;

      var lbShow = function (i) {
        lbIndex = (i + slides.length) % slides.length;
        var slide = slides[lbIndex];
        var small = slide.querySelector('img');
        lbImg.src = slide.getAttribute('data-zoom') || (small && small.currentSrc) || '';
        lbImg.alt = small ? small.alt : '';
        if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + slides.length;
        // warm the next photo so arrowing through is instant
        var nextSlide = slides[(lbIndex + 1) % slides.length];
        if (nextSlide && nextSlide.getAttribute('data-zoom')) { var pre = new Image(); pre.src = nextSlide.getAttribute('data-zoom'); }
      };
      var openedAt = 0;
      var lbOpen = function () {
        if (lb.open) return;
        lbShow(index);
        lb.showModal();
        openedAt = Date.now();
        document.documentElement.classList.add('ihero-lb-open');
      };
      // clean-up runs directly (not only from the dialog's close event, which some browsers deliver late or not at all)
      var afterClose = function () {
        document.documentElement.classList.remove('ihero-lb-open');
        show(lbIndex);
      };
      var lbClose = function () {
        if (lb.open) lb.close();
        afterClose();
      };

      lb.addEventListener('cancel', function (e) { e.preventDefault(); lbClose(); }); // Escape
      lb.addEventListener('close', afterClose);
      // Open on a tap anywhere on the current photo. Detected from pointer events (a short press that hardly moves), not from
      // the click event alone: on some phones the browser never turned a tap on the photo into a click.
      var tap = null;
      var onPhoto = function (t) { return t && t.closest && t.closest('[data-slide]') && !t.closest('button'); };
      if (stage) {
        stage.addEventListener('pointerdown', function (e) {
          tap = (e.isPrimary && (e.pointerType !== 'mouse' || e.button === 0) && onPhoto(e.target)) ? { x: e.clientX, y: e.clientY, t: Date.now() } : null;
        });
        stage.addEventListener('pointerup', function (e) {
          if (!tap) return;
          var still = Math.abs(e.clientX - tap.x) < 12 && Math.abs(e.clientY - tap.y) < 12 && Date.now() - tap.t < 600;
          tap = null;
          if (still && Date.now() - swiped > 400) lbOpen();
        });
        stage.addEventListener('pointercancel', function () { tap = null; });
        // keyboard / assistive tech fallback (no pointer events): a plain click on a photo
        stage.addEventListener('click', function (e) {
          if (e.detail === 0 && onPhoto(e.target)) lbOpen();
        });
      }
      var zoomBtn = root.querySelector('[data-zoom-open]');
      if (zoomBtn) zoomBtn.addEventListener('click', lbOpen);
      lb.querySelector('[data-lb-close]').addEventListener('click', lbClose);
      if (lbPrev) lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });
      // a tap on the dark area around the photo closes
      lb.addEventListener('click', function (e) {
        // the click that follows the opening tap lands on the dialog: ignore it, or the view would close at once
        if (Date.now() - openedAt < 500) return;
        if (e.target === lb || e.target.hasAttribute('data-lb-stage')) lbClose();
      });
      lb.addEventListener('keydown', function (e) {
        if (slides.length < 2) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(lbIndex - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(lbIndex + 1); }
      });
      lb.addEventListener('touchstart', function (e) {
        lbTouches = e.touches.length;
        lbStartX = e.touches.length === 1 ? e.touches[0].clientX : null;
      }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        // ignore pinch gestures and swipes while the page is pinch-zoomed in
        if (lbStartX === null || lbTouches > 1 || (window.visualViewport && window.visualViewport.scale > 1.01)) { lbStartX = null; return; }
        var dx = e.changedTouches[0].clientX - lbStartX;
        if (Math.abs(dx) > 50 && slides.length > 1) lbShow(lbIndex + (dx < 0 ? 1 : -1));
        lbStartX = null;
      }, { passive: true });
    }

    /* Variants */
    var dataEl = root.querySelector('[data-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }
    var idInput = root.querySelector('[data-variant-id]');
    var optionInputs = [].slice.call(root.querySelectorAll('input[data-option-index]'));
    var stock = root.querySelector('[data-stock]');
    var buyLabel = root.dataset.buyLabel || 'Add to cart';
    var isProductPage = root.dataset.pageType === 'product';

    function update() {
      var chosen = [];
      optionInputs.forEach(function (inp) {
        if (inp.checked) chosen[+inp.dataset.optionIndex] = inp.value;
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === chosen[i]; });
      });
      var ok = !!v && v.available;
      root.querySelectorAll('[data-add]').forEach(function (b) { b.disabled = !ok; });
      root.querySelectorAll('[data-add-label]').forEach(function (l) {
        l.textContent = !v ? 'Unavailable' : (v.available ? buyLabel : 'Sold out');
      });
      if (stock) { stock.textContent = ok ? 'In stock' : 'Sold out'; stock.classList.toggle('is-out', !ok); }
      if (!v) return;
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-price]').forEach(function (el) { el.innerHTML = v.price; });
      var cmp = root.querySelector('[data-compare]');
      if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.innerHTML = v.compare; }
      if (v.media) {
        var n = slides.findIndex(function (s) { return s.dataset.mediaId == v.media; });
        if (n > -1) show(n);
      }
      if (isProductPage && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    optionInputs.forEach(function (inp) { inp.addEventListener('change', update); });

    /* Buy now: add the selected variant to the cart, then go straight to checkout */
    var buyNow = root.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        var form = buyNow.form;
        if (!form || buyNow.disabled) return;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        buyNow.disabled = true;
        buyNow.classList.add('is-loading');
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: new FormData(form)
        }).then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.href = base + 'checkout';
        }).catch(function () {
          /* plain form post: Shopify shows the reason (e.g. out of stock) on the cart page */
          form.submit();
        });
      });
    }

    /* Sticky bar: shows once the main button has scrolled out of view */
    var sticky = root.querySelector('[data-sticky]');
    var mainBtn = root.querySelector('.ihero__form [data-add]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      }).observe(mainBtn);
    }

    /* App buttons injected into the card (back-in-stock alert etc.): force black with white text.
       Done in JS because these buttons often carry inline styles or sit in a shadow root. */
    var card = root.querySelector('.ihero__card');
    var APP_BTN = /back in stock|stock alert|notify me|restock/i;

    function paint(scope) {
      var all = scope.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.shadowRoot) paint(el.shadowRoot);
        if (el.closest && el.closest('.ihero__btn')) continue;
        var tag = el.tagName;
        if (!(el.children.length === 0 || tag === 'BUTTON' || tag === 'A' || tag === 'INPUT')) continue;
        var text = (el.textContent || el.value || '').trim();
        if (!text || text.length > 60 || !APP_BTN.test(text)) continue;
        var target = el, hops = 0;
        while (target && target !== card && hops < 4) {
          var bg = getComputedStyle(target).backgroundColor;
          if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') break;
          target = target.parentElement;
          hops++;
        }
        if (!target || target === card || hops >= 4) target = el;
        target.style.setProperty('background', '#000', 'important');
        target.style.setProperty('background-color', '#000', 'important');
        target.style.setProperty('border-color', '#000', 'important');
        target.style.setProperty('color', '#fff', 'important');
        el.style.setProperty('color', '#fff', 'important');
      }
    }
    if (card) {
      var queued = false;
      var run = function () { queued = false; paint(card); };
      var queue = function () { if (!queued) { queued = true; setTimeout(run, 60); } };
      run();
      [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(run, ms); });
      if ('MutationObserver' in window) {
        new MutationObserver(queue).observe(card, { childList: true, subtree: true });
      }
    }
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-ihero]'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
